import AlertModal from "components/AlertModal/AlertModal";
import React from "react";

function VmErrorScreen({ errorMessages }) {
  return (
    <AlertModal
      open={true}
      modalTitle={errorMessages.title}
      modalDescription={errorMessages.description}
    />
  );
}

export default VmErrorScreen;
